import config from '../config'
import { authorizedFetch } from '../utils/auth.js'
import { checkStatus } from '../utils/fetch'
import { logOut } from '../actions/users'

export const REQUEST_LOCATIONS = 'REQUEST_LOCATIONS'
export const RECEIVED_LOCATIONS = 'RECEIVED_LOCATIONS'
export const SHOW_ADD_LOCATION_FORM = 'SHOW_ADD_LOCATION_FORM'
export const CLOSE_ADD_LOCATION_FORM = 'CLOSE_ADD_LOCATION_FORM'
export const UPDATE_LOCATION_FIELD = 'UPDATE_LOCATION_FIELD'
export const UPDATE_LOCATION_SUCCEDED = 'UPDATE_LOCATION_SUCCEDED'

export const MOVE_UP_SUCCEDED = 'MOVE_UP_SUCCEDED'
export const MOVE_DOWN_SUCCEDED = 'MOVE_DOWN_SUCCEDED'

export const DELETE_LOCATION_SUCCEDED = 'DELETE_LOCATION_SUCCEDED'
export const CHANGE_LOCATION_IMAGE = 'CHANGE_LOCATION_IMAGE'
export const CANCEL_LOCATION_IMAGE = 'CANCEL_LOCATION_IMAGE'
export const CHANGE_PAGE = 'CHANGE_PAGE_LOCATIONS'

export const SHOW_LOCATION_CALENDAR = 'SHOW_LOCATION_CALENDAR'
export const CLOSE_LOCATION_CALENDAR = 'CLOSE_LOCATION_CALENDAR'
export const CHANGE_CALENDAR_VIEW = 'CHANGE_CALENDAR_VIEW'
export const CHANGE_CALENDAR_DATE = 'CHANGE_CALENDAR_DATE'

export const REQUEST_BOOKINGS = 'REQUEST_BOOKINGS'
export const RECEIVED_BOOKINGS = 'RECEIVED_BOOKINGS'
export const SHOW_SPINNER = 'SHOW_SPINNER'
export const UPDATE_LOCATIONS_FILTER = 'UPDATE_LOCATIONS_FILTER'
export const SHOW_AVATAR = 'SHOW_AVATAR'
export const UPDATE_HAS_TV = 'UPDATE_HAS_TV'
export const UPDATE_BRIVO = 'UPDATE_BRIVO'

export const updateFilter = (filter, value) => ({
  type: UPDATE_LOCATIONS_FILTER,
  filter: filter,
  value: value
})

export const requestBookings = () => ({
  type: REQUEST_BOOKINGS
})

export const receivedBookings = json => ({
  type: RECEIVED_BOOKINGS,
  json: json.data
})

export const fetchBookings = location => dispatch => {
  dispatch(requestBookings())
  authorizedFetch(config.api_url + 'locations/bookings/' + location._id)
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(receivedBookings({ data: json })))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const requestLocations = () => ({
  type: REQUEST_LOCATIONS
})

export const receivedLocations = json => ({
  type: RECEIVED_LOCATIONS,
  json: json.data
})

export const fetchLocations = (filters, skip, take) => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  dispatch(requestLocations())
  authorizedFetch(config.api_url + 'locations/list', {
    headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ filters, skip, take })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(receivedLocations({ data: json })))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const showLocationCalendar = location => ({
  type: SHOW_LOCATION_CALENDAR,
  location: location
})

export const closeLocationCalendar = () => ({
  type: CLOSE_LOCATION_CALENDAR
})

export const showUpdateLocationForm = location => ({
  type: SHOW_ADD_LOCATION_FORM,
  location: location
})

export const closeAddLocationForm = () => ({
  type: CLOSE_ADD_LOCATION_FORM
})

export const updateField = (name, value) => ({
  type: UPDATE_LOCATION_FIELD,
  name: name,
  value: value
})

export const updateLocation = location => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'locations/update', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ location: location })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateLocationSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const updateLocationSucceded = location => ({
  type: UPDATE_LOCATION_SUCCEDED,
  location: location
})

export const moveUp = location => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'locations/moveUp', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ location: location })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(moveUpSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const moveUpSucceded = location => ({
  type: MOVE_UP_SUCCEDED,
  location: location
})

export const moveDown = location => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'locations/moveDown', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ location: location })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(moveDownSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const moveDownSucceded = location => ({
  type: MOVE_DOWN_SUCCEDED,
  location: location
})

export const deleteLocation = location => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'locations/delete', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ location: location })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(deleteLocationSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const deleteLocationSucceded = location => ({
  type: DELETE_LOCATION_SUCCEDED,
  location: location
})

export const cancelImage = () => ({
  type: CANCEL_LOCATION_IMAGE
})

export const changeImage = image => ({
  type: CHANGE_LOCATION_IMAGE,
  image: image
})

// calendar view actions
export const updateCalendarView = view => ({
  type: CHANGE_CALENDAR_VIEW,
  view: view
})

export const updateCalendarDate = date => ({
  type: CHANGE_CALENDAR_DATE,
  date: date
})

export const showSpinner = () => ({
  type: SHOW_SPINNER
})

export const updateAvailableSlot = (timeSlot, location) => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'locations/update', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ location: location })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateLocationSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}
export const showAvatar = showAvatar => ({
  type: SHOW_AVATAR,
  showAvatar: showAvatar
})

export const updateHasTv = (name, enabled) => ({
  type: UPDATE_HAS_TV,
  enabled,
  name
})

export const changePage = pageNumber => ({
  type: CHANGE_PAGE,
  pageNumber
})

export const updateBrivo = brivo => ({
  type: UPDATE_BRIVO,
  value: brivo
})



// WEBPACK FOOTER //
// ./src/actions/locations.js